import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { Typography, Paper, Box, Checkbox, Button } from "@mui/material";
import * as styles from "../Login/Styles.js";
import { Spaces } from "../../assets/Variables/SpaceVariables.js";
import Colors from "../../assets/Variables/ColorsVariables.js";
import logo_communitraders from "../../assets/logos/Logo-communitraders.svg";
import * as TextVariables from "../../assets/Variables/TextVariables.js";
import TitledInput from "../../components/Generals/Inputs/TitledInput.js";
import TitledPasswordInput from "../../components/Generals/Inputs/TitledPasswordInput.js";
import TitledSelector from "../Generals/Selectors/TitledSelector.js";
import ApplyButton from "../Generals/Buttons/ApplyButton.js";
import * as MasterData from "../../Master Data/masterData.js";
import LoadingSpinner from "../../components/Generals/Loaders/SpinLoader.js";
import userService from "../../services/user";
import loginService from "../../services/login";
import NotificationModal from "../Generals/Notifications/NotificationModal.js";
import { ClearSymbols } from "../../Tools/LocalStorage.js";

function LoginView( {type} ) {
  //#region "Instantiation of States"
  const [loading, setLoading] = useState(false);
  const [ip, setIp] = useState("");
  const [errors, setErrors] = useState({
    usu: false,
    pass: false,
    role: false,
    platform: false,
    server: false,
    checked: false,
  });
  const [formValues, setFormValues] = useState({
    usu: "",
    pass: "",
    role: "",
    platform: "",
    server: "",
    checked: false,
  });
  const [modalProps, setModalProps] = useState({
    open: false,
    iconType: "",
    title: "",
    message: "",
    onAcceptLabel: undefined,
    onRefuseLabel: undefined,
    onAccept: undefined,
    onRefuse: undefined,
  });
  const [signalLogin, setSignalLogin] = useState(0);
  const navigate = useNavigate();
  const cookies = new Cookies();
//#endregion
  
  //#region "Handlers"
  const handleSubmit = () => {
    let valid = true;
    let newErrors = {};

    for (const [key, value] of Object.entries(formValues)) {
      if (value === "" || value === false) {
        newErrors[key] = true;
        valid = false;
      } else {
        newErrors[key] = false;
      }
    }

    setErrors(newErrors);

    if (valid) {
      handleLogin();
    } else {
      setModalProps({
        open: true,
        iconType: "error",
        title: "Please, fill in the missing data",
        onAcceptLabel: "Continue",
        onAccept: () => handleCloseNotification(),
      });
    }
  };

  const handleCloseNotification = (prevModalProps) => {
    setModalProps({ ...prevModalProps, open: false });
  };

  const handleUserInput = (event) => {
    const inputValue = event.target.value.replace(/[^0-9]/g, "");
    if (inputValue.length <= 10) {
      setFormValues({
        ...formValues,
        usu: inputValue,
      });
    }
  };

  const handleEmailInput = (event) => {
    const inputValue = event.target.value.toLowerCase().trim();
    setFormValues({
      ...formValues,
      usu: inputValue,
    });
  };

  const handlePasswordInput = (event) => {
    if (event.target.value.length <= 30) {
      setFormValues({
        ...formValues,
        pass: event.target.value,
      });
    }
  };

  const handleRoleSelector = (event) => {
    setFormValues({
      ...formValues,
      role: event.target.value,
    });
  };

  const handlePlatformSelector = (event) => {
    setFormValues({
      ...formValues,
      platform: event.target.value,
    });
  };

  const handleServerSelector = (event) => {
    setFormValues({
      ...formValues,
      server: event.target.value,
    });
    cookies.set("url", event.target.value, { path: "/" });
    const urlUpdatedEvent = new CustomEvent("updatedUrl", {
      detail: { value: event.target.value },
    });

    window.dispatchEvent(urlUpdatedEvent);
  };

  const handleDisclouserCheck = (event) => {
    setFormValues({
      ...formValues,
      checked: event.target.checked,
    });
  };

  const handleLogin = (e) => {
    //Calls login service to do login into the communitraders api
    setLoading(true);
    loginService.login({
        //Login request body
        platform: formValues.platform,
        environment: formValues.server,
        role: formValues.role,
        account: formValues.usu,
        password: formValues.pass,
        ip: ip,
      })
      .then((response) => {
        return response.data;
      })
      .then((response) => {
        //Checking out if the response return the login data
        if (response.data != null) {
          var user = response.data;
          cookies.set("token", user.token, { path: "/" });
          const tokenUpdatedEvent = new CustomEvent("tokenUpdatedEvent", {
            detail: { value: user.token },
          });

          window.dispatchEvent(tokenUpdatedEvent);

          //If the response was correct, the credentials hooks are deleted
          let loginMessage = "";

          // Checks out if the account type is signal or follower
          if (formValues.role === "signal") {
            //If the account type is signal, set the cookies with the access data (user, account type and token)
            cookies.set("user", formValues.usu, { path: "/" });
            cookies.set("account type", formValues.role, { path: "/" });
            navigate("/signal-provider/profile");
            //If the account type is signal the disclouser screen will be displayed
            loginMessage = "login.Welcome signal provider user";
          } 
          else if (formValues.role === "follower") {
            //If the account type is follower, set the cookies with the access data (user, account type and token)
            cookies.set("user", formValues.usu, { path: "/" });
            cookies.set("account type", formValues.role, { path: "/" });

            const sharedSignal = localStorage.getItem("shared_signal_link");
            if(sharedSignal && sharedSignal.length > 0){
              navigate("/shared_signal_link/"+sharedSignal);
              return;
            }

            if (signalLogin !== 0) {
              navigate(`/follower/discover/strategy/${signalLogin}`);
            } 
            else {
              RequestSignalExist();
            }
          }
          else if (formValues.role === "admin") {
            cookies.set("user", formValues.usu, { path: "/" });
            cookies.set("account type", formValues.role, { path: "/" });

            navigate("/admin/dashboard");
          }
        } else {
          setModalProps({
            open: true,
            iconType: "error",
            title: "Invalid access credentials",
            onAcceptLabel: "Continue",
            onAccept: () => handleCloseNotification(),
          });
        }
      })
      .catch((error) => {
        if (error.response.status >= 400 && error.response.status < 500 && error.response.data.message) {
          setModalProps({
            open: true,
            iconType: "error",
            title: "Detected error",
            message: error.response.data.message,
            onAcceptLabel: "Continue",
            onAccept: () => handleCloseNotification(),
          });
        } else {
          setModalProps({
            open: true,
            iconType: "error",
            title: "Server error",
            message: "An unexpected error has occurred, please contact an administrator",
            onAcceptLabel: "Continue",
            onAccept: () => handleCloseNotification(),
          });
        }
      });

      setLoading(false);
  };

  //#endregion
  
  //#region "Requests"
  const getIp = () => {
    setLoading(true); //Starts loading spinning
    userService
      .getIpClient //Calls the method getIpClient from user service (axios request)
      ()
      .then((response) => {
        //Waits for a response from the axios request
        setLoading(false); //Stops loading spinning
        return response;
      })
      .then((response) => {
        if (response !== null) {
          setIp(response.data); //If response is correct, sets ip into the hook ip.
        } else {
          getIp();
        }
      })
      .catch((error) => {
        setLoading(false); //Stops loading spinning
        getIp();
      });
  };

  const RequestSignalExist = async () => {
    try {
      const response = await userService.getInformation();
      if (response.data != null) {
        setLoading(false)
        if (response.data.signal_followed) {
          navigate(`/follower/discover/strategy/${response.data.signal_followed}`);
        } else {
          navigate(`/follower/following-settings`);
        }
      }
    } catch {
      navigate(`/follower/discover`);
    }
  };
  
//#endregion

  //#region "useEffects"
  //USe Effect hook triggered once per render, it calls a function to request the user ip
  useEffect(() => {
    getIp();

    if(type === "admin"){
      cookies.remove("user", { path: "/" });
      cookies.remove("account type", { path: "/" });
      cookies.remove("token", { path: "/" });

      setFormValues({
        ...formValues,
        role: "admin",
      });
    }
    else{
      const path = window.location.pathname;
      const signalLogin = path.split("/").pop();
      if ( signalLogin !== undefined && signalLogin.length > 0 && signalLogin !== "login") {
        setSignalLogin(signalLogin);
        const user = cookies.get("user");
        const userType = cookies.get("account type"); //Gets from cookies is the user is Signal provider type
        const token = cookies.get("token"); //Gets from cookies is the user is Signal provider type
        if ( token !== undefined && token.length >= 7 && user !== undefined && user.length >= 0 && userType !== undefined) {
          if(userType === "follower"){
            navigate(`/follower/discover`);
          }
          else{
            navigate(`/signal-provider/profile`);
          }
        }
      } 
      else {
        cookies.remove("user", { path: "/" });
        cookies.remove("account type", { path: "/" });
        cookies.remove("token", { path: "/" });
      }
    }
    
    ClearSymbols();

    localStorage.removeItem('selectedAssets');
    localStorage.removeItem('selectedCurrencies');
    localStorage.removeItem('symbolsData');
    localStorage.removeItem('followingSettings');
    localStorage.removeItem('visibility');
    localStorage.removeItem('userInformation');
  }, []);

//#endregion
  

  //#region "HTML"
  return (
    <Box sx={styles.mainContainer}>
      {loading ? <LoadingSpinner /> : <></>}
      <NotificationModal
        open={modalProps.open}
        onClose={handleCloseNotification}
        iconType={modalProps.iconType}
        title={modalProps.title}
        message={modalProps.message}
        onAcceptLabel={modalProps.onAcceptLabel}
        onAccept={modalProps.onAccept}
      />
      <Box sx={styles.logoContainer}>
        <img src={logo_communitraders} alt="Tradeview" width={"233"} />
        <Typography sx={styles.logoTitle}>
          {type === "admin"
            ? "Account Management within the Copier - Autorized Access Only"
            : "Follow experienced traders or share your own trading expertise!"
          }
        </Typography>
      </Box>
      <Box sx={styles.formContainer}>
        <Paper elevation={1} sx={styles.mainPaperForm}>
          <Paper elevation={1} sx={styles.paperForm}>
            <Box sx={styles.loginTitleBox}>
              <Typography
                sx={{ fontFamily: TextVariables.Body_2_Bold, lineHeight: "1" }}
              >
                Login to your account
              </Typography>
              <Typography
                sx={{
                  fontFamily: TextVariables.Body_4,
                  color: Colors.Secondary_600,
                }}
              >
                {type === "admin"
                  ? 
                  <>
                    You can access Communitraders here only as a Administrator using your email registered with tech support system.
                    If you are a user (signal provider or follower) click { }
                    
                  </>
                  : 
                  <>
                    You can access Communitraders as a Follower or Signal Provider using your MetaTrader credentials. To become a Signal Provider, register { }
                  </>
                  }
                <Button
                  component="a"
                  href={type === "admin" ? "/login" : "/signal-register"}
                  sx={{
                    color: "blue",
                    textDecoration: "underline",
                    cursor: "pointer",
                    padding: 0,
                    margin: 0,
                    minWidth: "auto",
                    textTransform: "none",
                    background: "none",
                    fontFamily: TextVariables.Body_4,
                    verticalAlign: "0",
                    "&:hover": {
                      background: "none",
                      textDecoration: "underline",
                    },
                  }}
                >
                  here
                </Button>
              </Typography>
            </Box>
            <Box sx={styles.loginInputsBox}>
              <TitledInput
                name="login"
                value={formValues.usu}
                title={type === "admin" ? "Email account" : "MetaTrader account number"}
                placeholder={type === "admin" ? "Enter you email" : "Enter your login"}
                handleChange={type === "admin" ? handleEmailInput : handleUserInput}
                error={errors.usu}
                helperText={
                  errors.usu ? (
                    <Box sx={styles.emptyFieldLabel}>
                      <span
                        className="material-symbols-outlined"
                        style={{ fontSize: Spaces.Size_3, color: "red" }}
                      >
                        error
                      </span>
                      <Typography
                        sx={{
                          fontFamily: TextVariables.Caption_1,
                          color: Colors.Error_700,
                        }}
                      >
                        Please, enter your user
                      </Typography>
                    </Box>
                  ) : (
                    ""
                  )
                }
              ></TitledInput>
              <TitledPasswordInput
                name="password"
                title={"Password"}
                value={formValues.pass}
                type="password"
                placeholder={"Enter your password"}
                handleChange={handlePasswordInput}
                error={errors.pass}
                helperText={
                  errors.pass ? (
                    <Box sx={styles.emptyFieldLabel}>
                      <span
                        className="material-symbols-outlined"
                        style={{ fontSize: Spaces.Size_3, color: "red" }}
                      >
                        error
                      </span>
                      <Typography
                        sx={{
                          fontFamily: TextVariables.Caption_1,
                          color: Colors.Error_700,
                        }}
                      >
                        Please enter your password
                      </Typography>
                    </Box>
                  ) : (
                    ""
                  )
                }
              >
              </TitledPasswordInput>
              {type === "admin" ? 
                null
                : 
                <>
                  <TitledSelector
                    title={"Role"}
                    name="role"
                    value={formValues.role}
                    handleChange={handleRoleSelector}
                    options={MasterData.roleOptions}
                    error={errors.role}
                    placeholder={"Select a role"}
                    helperText={
                      errors.role ? (
                        <Box sx={styles.emptyFieldLabel}>
                          <span
                            className="material-symbols-outlined"
                            style={{ fontSize: Spaces.Size_3, color: "red" }}
                          >
                            error
                          </span>
                          <Typography
                            sx={{
                              fontFamily: TextVariables.Caption_1,
                              color: Colors.Error_700,
                            }}
                          >
                            Please, select a role
                          </Typography>
                        </Box>
                      ) : (
                        ""
                      )
                    }
                  /> 
                </>
              }
              <TitledSelector
                title={"Platform"}
                name="platform"
                value={formValues.platform}
                handleChange={handlePlatformSelector}
                options={MasterData.platformOptions}
                placeholder={"Select a platform"}
                error={errors.platform}
                helperText={
                  errors.platform ? (
                    <Box sx={styles.emptyFieldLabel}>
                      <span
                        className="material-symbols-outlined"
                        style={{ fontSize: Spaces.Size_3, color: "red" }}
                      >
                        error
                      </span>
                      <Typography
                        sx={{
                          fontFamily: TextVariables.Caption_1,
                          color: Colors.Error_700,
                        }}
                      >
                        Please select a platform
                      </Typography>
                    </Box>
                  ) : (
                    ""
                  )
                }
              />
              <TitledSelector
                title={"Server"}
                name="server"
                value={formValues.server}
                handleChange={handleServerSelector}
                options={
                  formValues.platform === "metatrader4"
                    ? MasterData.serverOptionsMt4
                    : MasterData.serverOptionsMt5
                }
                placeholder={"Select a server"}
                error={errors.server}
                helperText={
                  errors.server ? (
                    <Box sx={styles.emptyFieldLabel}>
                      <span
                        className="material-symbols-outlined"
                        style={{ fontSize: Spaces.Size_3, color: "red" }}
                      >
                        error
                      </span>
                      <Typography
                        sx={{
                          fontFamily: TextVariables.Caption_1,
                          color: Colors.Error_700,
                        }}
                      >
                        Please select a server
                      </Typography>
                    </Box>
                  ) : (
                    ""
                  )
                }
              />
            </Box>
            <Box sx={styles.disclaimerContainer}>
              <Checkbox
                checked={formValues.checked}
                onChange={handleDisclouserCheck}
                color="primary"
                sx={{ padding: "0px" }}
              />
              <Box>
                <Typography sx={{ fontFamily: TextVariables.Overline }}>
                  {" "}
                  By checking this box, I declare that I agree to the terms of the CommuniTraders Acknowledgement and Agreement, which states that Tradeview Financial Markets S.A.C (Tradeview SAC) has made no representation regarding the potential profitability of any signal service (Service) and does not endorse any of them. I also acknowledge the significant risk of loss involved in trading any instrument in any market. I agree that Tradeview SAC will execute signals generated by the Service on a best-effort basis. I accept the Communitraders Software (Copier Software) 'as is' and agree that Tradeview SAC shall have no liability for losses to my account and no responsibility for advising me of any changes or updates to the Copier Software or the Service. I acknowledge that it is my responsibility to stay informed about my account activity, the status of the Service, and the Copier Software. I agree that Tradeview SAC is not responsible for any loss in my account caused by mechanical, electronic, system, software, or communication failure, or any other cause beyond Tradeview SAC’s control. I hereby indemnify and hold harmless Tradeview SAC, its principals, agents, directors, shareholders, officers, and employees for any losses, costs, expenses, or other liabilities (including reasonable attorney/accountant fees) I may experience as a result of using the Copier Software or the Service.
                </Typography>
                {errors.checked && (
                  <Typography sx={styles.emptyFieldLabel}>
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: Spaces.Size_3, color: "red" }}
                    >
                      error
                    </span>
                      Please, check the box to continue
                  </Typography>
                )}
              </Box>
            </Box>

            <Box sx={styles.loginButtonContainer}>
              <ApplyButton HandleOnClick={handleSubmit}>Continue</ApplyButton>
            </Box>
          </Paper>
        </Paper>
      </Box>
    </Box>
  );
  //#endregion
}

export default LoginView;
